import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const postAxiosReactionMsg = (channel, type, id, username) => {
  const { accessToken } = store.state.app.user
  const headers = {
    Authorization: `Bearer ${accessToken}`
  }
  axios
    .post(`${API_URL.MESSAGES}/${channel}/reaction`, { id, type, username }, { headers })
    .catch((err) => console.log(err.response.data))
}
